import SphericalMercator from "@mapbox/sphericalmercator";

export interface LngLatLike {
    lng: number;
    lat: number;
}

const EPSG = new SphericalMercator();

export function convertFromMM(unit: string, b: number) {
    if (unit == "" || unit == "mm") {
        return `${fmtNum(b, 1)} mm`;
    }
    if (unit == "in") {
        return `${fmtNum(b / 25.4, 2)} in`;
    }
    if (unit == "ft") {
        return `${fmtNum(b / (25.4 * 12), 2)} ft`;
    }
    if (unit == "cm") {
        return `${fmtNum(b / 10, 2)} cm`;
    }
    if (unit == "dm") {
        return `${fmtNum(b / 100, 2)} dm`;
    }
    if (unit == "m") {
        return `${fmtNum(b / 1000, 3)} m`;
    }
    if (unit == "yd") {
        return `${fmtNum(b / (125.4 * 12 * 3), 3)} yd`;
    }
    return `${unit} mm`;
}

export function getParts(a: string): [string, string] | [null, null] {
    const arr = a.match(/([\d\.]*)([\s\S]*)/);
    if (arr === null) {
        return [null, null];
    }
    if (arr.length == 3) {
        return [arr[1].trim(), arr[2].trim()];
    } else if (arr?.length == 2) {
        return [arr[1].trim(), "mm"];
    } else {
        return [arr[0].trim(), "mm"];
    }
}

export function convertToMm(a: string): number {
    const [qty, unit] = getParts(a);
    if (qty === null) {
        return 0;
    }
    if (unit == "" || unit == "mm") {
        return parseFloat(qty);
    }
    if (unit == "in") {
        return parseFloat(qty) * 25.4;
    }
    if (unit == "ft") {
        return parseFloat(qty) * 25.4 * 12;
    }
    if (unit == "cm") {
        return parseFloat(qty) * 10;
    }
    if (unit == "dm") {
        return parseFloat(qty) * 100;
    }
    if (unit == "m") {
        return parseFloat(qty) * 1000;
    }
    if (unit == "yd") {
        return parseFloat(qty) * 125.4 * 12 * 3;
    }
    return 0;
}

export function fmtNum(x: number, digits: number): string {
    return `${Math.floor(x * 10 ** digits) / 10 ** digits}`;
}

export function fmtLat(x: number): string {
    if (x < 0) {
        return fmtNum(-x, 4) + "° S";
    }
    return fmtNum(x, 4) + "° N";
}

export function fmtLon(x: number): string {
    if (x < 0) {
        return fmtNum(-x, 4) + "° W";
    }
    return fmtNum(x, 4) + "° E";
}

export function estMeters(ap: LngLatLike, bp: LngLatLike): [number, number] {
    const [ax, ay] = EPSG.forward([ap.lng, ap.lat]);
    const [bx, by] = EPSG.forward([bp.lng, bp.lat]);
    return [bx - ax, by - ay];
}

export function fmtDist(a: number): string {
    if (a >= 1e6) {
        return `${fmtNum(a / 1e6, 2)} Mm`;
    }
    if (a >= 1e3) {
        return `${fmtNum(a / 1e3, 2)} km`;
    }
    return `${a} m`;
}

export function fmtS(a: number): string {
    let parts: string[] = [];
    if (a > 24 * 3600) {
        parts.push(`${Math.floor(a / 3600 / 24)}d`);
        a %= (3600 * 24);
    }
    if (a > 3600) {
        parts.push(`${Math.floor(a / 3600)}h`);
        a %= 3600;
    }
    if (a > 60) {
        parts.push(`${Math.floor(a / 60)}m`);
        a %= 60;
    }
    parts.push(`${fmtNum(a, 2)}s`);
    return "".concat(...parts);
}
